export enum FormState {
    VALID = "VALID",
    INVALID = "INVALID"
}